// extracted by css-extract-rspack-plugin
export default {"cls1":"ContinueReadingWorkCard-cls1_wIq","cls2":"ContinueReadingWorkCard-cls2_V5Y ContinueReadingWorkCard-cls1_wIq"};